<script>
    import s from '../../style.module.css';
    export let starSize = 12;
    export let wrapperSize = '16px';
    export let type = 'full';

    import StarSVG from 'general/components/trustpilotStars/components/StarSVG.svelte';
</script>

<div
    style={`width: ${wrapperSize}px; height: ${wrapperSize}px;`}
    class={`${s.star} ${s[type]}`}
    title={`${type} star`}
>
    <StarSVG size={starSize} />
</div>
